import { FC, useCallback, useState } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { useAppDispatch, useAppSelector } from "store";
import { useCapabilities } from "store/capability-hooks";
import { pageSelectors, selectHasStudentsNotInGroupByPageId } from "store/selectors";
import { viewStateActions } from "store/slices/view";
import { useObjectSelector } from "store/store-hooks";
import { isGroupPage } from "utils/page-utils";
import { usePresentation } from "utils/presentation";

interface StudentsNotInGroupBannerProps {
  pageId: string;
}

export const StudentsNotInGroupBanner: FC<StudentsNotInGroupBannerProps> = ({ pageId }) => {
  const dispatch = useAppDispatch();
  const showGroupConfig = useCallback(
    () => dispatch(viewStateActions.setShowGroupConfig(true)),
    [dispatch],
  );
  const [showBanner, setShowBanner] = useState(true);
  const { canAuthorSection } = useCapabilities();
  const { hasProjectorView } = usePresentation();
  const page = useObjectSelector((s) => pageSelectors.selectById(s, pageId), ["interaction_mode"]);
  const hasStudentsNotInGroup = useAppSelector((s) =>
    selectHasStudentsNotInGroupByPageId(s, pageId),
  );

  const showStudentsNotInGroupBanner =
    !hasProjectorView && canAuthorSection && isGroupPage(page) && hasStudentsNotInGroup;

  if (!showStudentsNotInGroupBanner) {
    return null;
  }

  return showBanner ? (
    <Banner
      actionButtonText={t("warning.review_groups")}
      className="group-card"
      kind="warning"
      onAction={showGroupConfig}
      onDismiss={() => setShowBanner(false)}
    >
      {t("warning.not_assigned_to_groups")}
    </Banner>
  ) : null;
};
